export function getNextSortDirection(previousSort, key, defaultDirection = "descending") {
  if (!previousSort || previousSort.key !== key) return defaultDirection;
  return previousSort.direction === "ascending" ? "descending" : "ascending";
}

export function syncSortHeaders(headers, sortState, activePanel) {
  const state = sortState.get(activePanel);

  headers.forEach((header) => {
    const isSortedHeader = state && header.dataset.sortKey === state.key;
    const nextDirection = isSortedHeader ? state.direction : "none";
    const isActive = isSortedHeader && nextDirection !== "none";

    header.setAttribute("aria-sort", nextDirection);
    header.dataset.active = isActive ? "true" : "false";

    const indicator = header.querySelector("[aria-hidden='true']");
    if (indicator) {
      indicator.dataset.active = isActive ? "true" : "false";
    }
  });
}

export function applySort(panel, key, activeHeader, direction, headers, sortState) {
  const rows = panel.querySelector(".project-viewer-v2__rows");
  if (!rows) return;

  const sortedRows = Array.from(rows.children).sort((firstRow, secondRow) => {
    const firstValue = firstRow.dataset[key] || "";
    const secondValue = secondRow.dataset[key] || "";

    let comparison;
    if (key === "year") {
      comparison = Number(firstValue || 0) - Number(secondValue || 0);
    } else {
      comparison = firstValue.localeCompare(secondValue, undefined, {
        numeric: true,
        sensitivity: "base",
      });
    }

    return direction === "ascending" ? comparison : -comparison;
  });

  sortedRows.forEach((row) => rows.append(row));
  sortState.set(panel, { key, direction });

  headers.forEach((header) => {
    const isActive = header === activeHeader;
    header.setAttribute("aria-sort", isActive ? direction : "none");
    header.dataset.active = isActive ? "true" : "false";

    const indicator = header.querySelector("[aria-hidden='true']");
    if (indicator) {
      indicator.dataset.active = isActive ? "true" : "false";
    }
  });
}
